import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { BuilderVisual } from '../components/BuilderVisual';
export const KitBuilder = () => <div className="bg-ink min-h-screen flex flex-col items-center justify-center p-6 relative overflow-hidden" data-id="element-543">
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-544">
      <div className="absolute top-1/4 left-1/4 w-[50%] h-[50%] rounded-full bg-brandRed/10 blur-[120px]" data-id="element-545"></div>
    </div>

    <div className="relative z-10 max-w-5xl w-full text-center flex flex-col items-center" data-id="element-546">
      <span className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-brandRed mb-5" data-id="element-547">
        <span className="w-8 h-px bg-brandRed" data-id="element-548"></span>
        3D Uniform Builder
      </span>

      <h1 className="text-4xl md:text-6xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-549">
        Build Your Uniform.
        <br data-id="element-550" />
        See It Instantly in 3D.
      </h1>

      <p className="text-xl text-gray-300 mb-12 max-w-2xl leading-relaxed" data-id="element-551">
        Choose styles, colors, patterns, fabrics, and options — then submit your
        design for wholesale production support.
      </p>

      <div className="w-full max-w-4xl mb-12" data-id="element-552">
        <BuilderVisual theme="dark" data-id="element-553" />
      </div>

      <div className="flex flex-col sm:flex-row gap-4 items-center" data-id="element-554">
        <Link to="/wholesale-apply" className="bg-brandRed hover:bg-brandRedDark text-white font-bold py-4 px-8 rounded-sm transition-colors flex items-center gap-2 group text-base" data-id="element-555">
          Apply for Wholesale Access
          <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-556" />
        </Link>
        <Link to="/" className="flex items-center gap-2 text-white hover:text-brandRed transition-colors font-semibold" data-id="element-557">
          <ArrowLeft className="w-5 h-5" data-id="element-558" /> Return to Homepage
        </Link>
      </div>
    </div>
  </div>;